
const square_check = require('../../../assets/images/fontAwesomeIcons/square-check-regular.svg').default
const square_cross = require('../../../assets/images/fontAwesomeIcons/square-xmark-solid.svg').default

export function BooleanValueTemplate({ value }: any) {
    const imageSrc = value ? square_check : square_cross
    const alt = value.toString()
    return (
        <div className="boolean-value">
            <img src={imageSrc} alt={alt} />
        </div>
    )
}
